import axios from 'axios'
import { API_BASE_PATH } from '../Config/Config'
import {useQuery} from '@tanstack/react-query'

const getApps = async (productId) => {
     const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);


const response = await axios.get(`${API_BASE_PATH}/KeyLogging/product/${productId}`)
  return response.data
}

const useGetAppsQuery = (productId, options = {}) => {
    return useQuery({
        queryKey: ['apps', productId],
        queryFn: () => getApps(productId),
        ...options
    })
}
export default useGetAppsQuery;

